import { render, staticRenderFns } from "./course_publish_management.vue?vue&type=template&id=500196fe&scoped=true&"
import script from "./course_publish_management.vue?vue&type=script&lang=js&"
export * from "./course_publish_management.vue?vue&type=script&lang=js&"
import style0 from "./course_publish_management.vue?vue&type=style&index=0&id=500196fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500196fe",
  null
  
)

export default component.exports